import React from 'react';
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import { IconButton } from '@mui/material';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { CustomTooltip } from '../../consts';
import { CAMPAIGN_PINNED_FAILED, CAMPAIGN_PINNED_SUCCESS, CAMPAIGN_UNPINNED_SUCCESS } from '../../helpers/messages';
import Utils from '../../utils';
import { useThemeMode } from '../../components/theme';

const PinUnpinConfirmButton = ({ data, onSuccess }) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();
    const { colours } = useThemeMode();

    const handleDeleteConfirm = async (e) => {
        try {
            setIsLoading(true)
            await Utils.genericMutation("updateCampaign", {
                id: data.id,
                pinned: !data.pinned,
            });
            setIsLoading(false);
            showSnackbar(data.pinned ? CAMPAIGN_UNPINNED_SUCCESS : CAMPAIGN_PINNED_SUCCESS);
            setOpen(false);
            onSuccess(!data.pinned);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            showSnackbar(CAMPAIGN_PINNED_FAILED, "error");
        }
    };

    const renderConfirm = () => {
        return (<ConfirmDialog
            open={open}
            loading={isLoading}
            onClose={setOpen}
            onConfirm={handleDeleteConfirm}
            title="Please Confirm"
            okText="Okay"
            message={`Are you sure you want to ${data.pinned ? "Unpin" : "Pin"} this campaign?`}
        />)
    }

    const handleClick = (e) => {
        setOpen(true);
    }

    return (
        <>
            {renderConfirm()}
            <CustomTooltip title={data.pinned ? "Pinned" : "Unpinned"}>
                <IconButton aria-label={data.pinned ? "Pinned" : "Unpinned"} size="small" color={data.pinned ? "primary" : "info"} sx={{ marginLeft: "-.5rem" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e);
                    }}
                >
                    <PushPinOutlinedIcon size={20} />
                </IconButton>
            </CustomTooltip>
        </>
    )
}

export default PinUnpinConfirmButton